"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.createEIP1193Provider = void 0;
var errors_1 = require("./errors");
/**
 * Takes a provider instance along with events
 * and requests to override and returns an EIP1193 provider
 *
 *  ## Example:
 *
 * *Overriding events: *
 * ```typescript
 * ```
 *
 * @param provider The provider to patch
 * @param requestPatch An `object` with the method to patch
 * and the implementation with which to patch
 * @param events Events to patch
 * @returns An EIP1193 Provider
 */
var createEIP1193Provider = function (provider, requestPatch) {
    var baseRequest;
    if (provider.request) {
        // Copy the original request method and bind the provider context to it
        baseRequest = provider.request.bind(provider);
    }
    else if (provider.sendAsync) {
        baseRequest = createRequest(provider);
    }
    var request = function (_a) {
        var method = _a.method, params = _a.params;
        return __awaiter(void 0, void 0, void 0, function () {
            var key;
            return __generator(this, function (_b) {
                key = method;
                // If the request method is set to null
                // this indicates this method is not supported
                if (requestPatch && requestPatch[key] === null) {
                    throw new errors_1.ProviderRpcError({
                        code: 4200,
                        message: "The Provider does not support the requested method: ".concat(method)
                    });
                }
                if (requestPatch && requestPatch[key]) {
                    // @ts-ignore // @TODO - Fix this type error
                    return [2 /*return*/, requestPatch[key]({ baseRequest: baseRequest, params: params })];
                }
                else if (baseRequest) {
                    return [2 /*return*/, baseRequest({ method: method, params: params })];
                }
                else {
                    throw new errors_1.ProviderRpcError({
                        code: 4200,
                        message: "The Provider does not support the requested method: ".concat(method)
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    provider.request = request;
    return provider;
};
exports.createEIP1193Provider = createEIP1193Provider;
var createRequest = function (provider) {
    return (function (_a) {
        var method = _a.method, params = _a.params;
        return new Promise(function (resolve, reject) {
            provider.sendAsync({
                id: 0,
                jsonrpc: '2.0',
                method: method,
                params: params
            }, function (error, _a) {
                var result = _a.result;
                if (error) {
                    reject(JSON.parse(error));
                }
                else {
                    resolve(result === undefined ? null : result);
                }
            });
        });
    });
};
